import { render, staticRenderFns } from "./WizardLoginRegisterBtn.vue?vue&type=template&id=44180fe0&scoped=true&"
import script from "./WizardLoginRegisterBtn.vue?vue&type=script&lang=js&"
export * from "./WizardLoginRegisterBtn.vue?vue&type=script&lang=js&"
import style0 from "./WizardLoginRegisterBtn.vue?vue&type=style&index=0&id=44180fe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44180fe0",
  null
  
)

export default component.exports